import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { DOMAIN_CONFIG, getPortalUrl } from "../../config/domains";

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { isAuthenticated, role } = useSelector((state) => state.auth);
  const location = useLocation();

  if (!isAuthenticated) {
    // If we're on portal site, redirect to login
    if (DOMAIN_CONFIG.IS_PORTAL_SITE) {
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
    // If we're on static site, redirect to portal domain login
    const loginUrl = getPortalUrl(`/login?redirect=${encodeURIComponent(location.pathname)}`);
    window.location.href = loginUrl;
    return null;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(role)) {
    // Redirect to appropriate dashboard based on role
    return <Navigate to='/user-dashboard' replace />;
  }

  return children;
};

export default ProtectedRoute;
